import { MoreHorizontal, LogOut, UserPlus, Users } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { MemberAvatars } from './ListMembers';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  ICON_SIZE,
} from '../design-system';

const SidebarListItem = ({
  list,
  isActive,
  isDragOver,
  isEditing,
  editingName,
  onEditingNameChange,
  onRename,
  onCancelEdit,
  onClick,
  onDragOver,
  onDragLeave,
  onDrop,
  membersRefreshKey,
  articleCount,
  listRole,
  onViewMembers,
  onInviteMember,
  onStartEditing,
  onDelete,
  onLeaveList,
}) => {
  const { t } = useTranslation(['sidebar']);
  const isOwner = listRole === 'owner';

  return (
    <div className="list-item-wrapper" data-testid="sidebar-custom-list">
      {isEditing ? (
        <div className="new-list-input">
          <input
            type="text"
            value={editingName}
            onChange={(e) => onEditingNameChange(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') onRename();
              if (e.key === 'Escape') onCancelEdit();
            }}
            onBlur={onRename}
            autoFocus
          />
        </div>
      ) : (
        <Link
          to={`/list/${list.id}`}
          className={`menu-item ${isActive ? 'active' : ''} ${isDragOver ? 'drag-over' : ''}`}
          onClick={onClick}
          onDragOver={onDragOver}
          onDragLeave={onDragLeave}
          onDrop={onDrop}
          aria-current={isActive ? 'page' : undefined}
        >
          <span>{list.name}</span>
          <span className="menu-item-right">
            <MemberAvatars key={membersRefreshKey} listId={list.id} />
            {articleCount > 0 && (
              <span className="menu-count">{articleCount}</span>
            )}
          </span>
        </Link>
      )}
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button
            className="list-menu-btn"
            aria-label={`${list.name}: ${t('sidebar:showMore')}`}
          >
            <MoreHorizontal size={ICON_SIZE.xs} />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="sidebar-row-menu" side="bottom" align="start" sideOffset={4}>
          <DropdownMenuItem onSelect={onViewMembers}>
            <Users size={ICON_SIZE.xxs} />
            <span>{t('sidebar:menu.members')}</span>
          </DropdownMenuItem>
          {isOwner && (
            <DropdownMenuItem onSelect={onInviteMember}>
              <UserPlus size={ICON_SIZE.xxs} />
              <span>{t('sidebar:menu.inviteMember')}</span>
            </DropdownMenuItem>
          )}
          <DropdownMenuSeparator />
          {isOwner ? (
            <>
              <DropdownMenuItem onSelect={onStartEditing}>
                <span>{t('sidebar:menu.rename')}</span>
              </DropdownMenuItem>
              <DropdownMenuItem onSelect={onDelete}>
                <span>{t('sidebar:menu.delete')}</span>
              </DropdownMenuItem>
            </>
          ) : (
            <DropdownMenuItem onSelect={onLeaveList}>
              <LogOut size={ICON_SIZE.xxs} />
              <span>{t('sidebar:menu.leaveList')}</span>
            </DropdownMenuItem>
          )}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export default SidebarListItem;
